export var loadingMixin = {
  methods: {
    setPostcardState: function(lastSelectedPostcard) {
      this.$store.commit('setSelectedPostcardId', lastSelectedPostcard.id);
      this.$store.commit(
        'setSelectedPostcardImage',
        lastSelectedPostcard.image
      );
      this.$store.commit(
        'setSelectedPostcardHandwriting',
        lastSelectedPostcard.handwriting
      );
      this.$store.commit(
        'setSelectedPostcardContact',
        lastSelectedPostcard.contact
      );
      this.$store.commit('setSelectedPostcardTo', lastSelectedPostcard.to);
      this.$store.commit('setSelectedPostcardFrom', lastSelectedPostcard.from);
      this.$store.commit(
        'setSelectedPostcardMessage',
        lastSelectedPostcard.message
      );
    }
  }
};
